import { render, staticRenderFns } from "./GroupwiseWeight.vue?vue&type=template&id=a77f0018&scoped=true"
import script from "./GroupwiseWeight.vue?vue&type=script&lang=js"
export * from "./GroupwiseWeight.vue?vue&type=script&lang=js"
import style0 from "./GroupwiseWeight.vue?vue&type=style&index=0&id=a77f0018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f0018",
  null
  
)

export default component.exports